export default __webpack_public_path__ + "static/media/FJ.84340fde.svg";